import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Alert, CircularProgress, Container, Link as MuiLink, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import { LanguageRecord, fetchLanguagesForDomain } from '../utils/formsApi';

const LanguagesListPage: React.FC = () => {
  const [languages, setLanguages] = useState<LanguageRecord[]>([]);
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;

    fetchLanguagesForDomain()
      .then((availableLanguages) => {
        if (isMounted) setLanguages(availableLanguages);
      })
      .catch((requestError) => {
        console.error('Failed to fetch languages:', requestError);
        if (isMounted) setError('Failed to load the available languages.');
      })
      .finally(() => {
        if (isMounted) setIsLoading(false);
      });

    return () => { isMounted = false; };
  }, []);

  return (
    <Container maxWidth="md" sx={{ mt: 4, mb: 4, textAlign: 'left' }}>
      <Typography component={Link} to="/" color="primary" sx={{ textDecoration: 'none' }}>
        ← Form Renderer
      </Typography>
      <Typography variant="h4" sx={{ mt: 2, mb: 3 }}>Available Languages</Typography>
      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
      {isLoading ? <CircularProgress aria-label="Loading languages" /> : (
        <Paper>
          <TableContainer>
            <Table aria-label="Available languages">
              <TableHead>
                <TableRow>
                  <TableCell>UUID</TableCell>
                  <TableCell>Language Code</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {languages.map((language) => (
                  <TableRow key={language.uuid} hover>
                    <TableCell sx={{ fontFamily: 'monospace', whiteSpace: 'nowrap' }}>
                      <MuiLink component={Link} to={`/languages/${encodeURIComponent(language.uuid)}`}>{language.uuid}</MuiLink>
                    </TableCell>
                    <TableCell>{language.languageCode}</TableCell>
                  </TableRow>
                ))}
                {languages.length === 0 && (
                  <TableRow><TableCell colSpan={2} align="center">No languages are available for this domain.</TableCell></TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
      )}
    </Container>
  );
};

export default LanguagesListPage;
